import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import CitySearch from './CitySearch';

const DashboardContainer = styled.div`
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid ${({ theme }) => theme.colors.grayLight};
`;

const Title = styled.h1`
  color: ${({ theme }) => theme.colors.greenPrimary};
`;

const LogoutButton = styled.button`
  background-color: ${({ theme }) => theme.colors.greenPrimary};
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.blueLight};
  }
`;

const Section = styled.section`
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  color: ${({ theme }) => theme.colors.grayDark};
  margin-bottom: 1rem;
  font-size: 1.5rem;
`;

const StatGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
`;

const StatCard = styled.div`
  background: ${({ theme }) => theme.colors.grayLight};
  padding: 1.5rem;
  border-radius: 8px;
  text-align: center;
`;

const StatNumber = styled.div`
  font-size: 2rem;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.greenPrimary};
  margin-bottom: 0.5rem;
`;

const StatLabel = styled.div`
  color: ${({ theme }) => theme.colors.grayDark};
`;

const Dashboard = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <DashboardContainer>
      <Header>
        <Title>Painel Administrativo</Title>
        <LogoutButton onClick={handleLogout}>Sair</LogoutButton>
      </Header>

      <Section>
        <SectionTitle>Visão Geral</SectionTitle>
        <StatGrid>
          <StatCard>
            <StatNumber>150</StatNumber>
            <StatLabel>Contatos Recebidos</StatLabel>
          </StatCard>
          <StatCard>
            <StatNumber>45</StatNumber>
            <StatLabel>Novos Leads</StatLabel>
          </StatCard>
          <StatCard>
            <StatNumber>8</StatNumber>
            <StatLabel>Projetos em Andamento</StatLabel>
          </StatCard>
        </StatGrid>
      </Section>

      <Section>
        <SectionTitle>Últimos Contatos</SectionTitle>
        {/* Aqui você pode adicionar uma tabela ou lista de contatos recentes */}
        <p>Em desenvolvimento: Lista de contatos recentes será exibida aqui.</p>
      </Section>

      <Section>
        <SectionTitle>Consulta SINIR - Dados Municipais</SectionTitle>
        <CitySearch />
      </Section>
    </DashboardContainer>
  );
};

export default Dashboard;
